import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { customAxios } from "lib/axios";
import { RolePermission } from "./addRole";

export interface GetRolesResponse {
  success: boolean;
  data: RolePermission[];
}

const getRolePermissions = async (): Promise<GetRolesResponse> => {
  const { data } = await customAxios.get<GetRolesResponse>(
    "/permissions/roles"
  );
  return data;
};

export const useGetRolePermissions = () =>
  useQuery<GetRolesResponse, AxiosError>(
    ["permissions-roles"],
    () => getRolePermissions(),
    {
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnMount: false, // Only refetch if cache is stale
    }
  );
